import { render, staticRenderFns } from "./desMiddleSearch.vue?vue&type=template&id=28037292"
import script from "./desMiddleSearch.vue?vue&type=script&lang=js"
export * from "./desMiddleSearch.vue?vue&type=script&lang=js"
import style0 from "./desMiddleSearch.vue?vue&type=style&index=0&id=28037292&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports